import { render, staticRenderFns } from "./PotensiPeluangView.vue?vue&type=template&id=ff5ec168&scoped=true"
import script from "./PotensiPeluangView.vue?vue&type=script&lang=js"
export * from "./PotensiPeluangView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5ec168",
  null
  
)

export default component.exports